import script from "./TeamMember.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMember.vue?vue&type=script&setup=true&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=0f596aaa&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f596aaa"]])

export default __exports__